import React, { useRef } from "react";
import * as three from "three";
import { useControls, folder } from "leva";
import useTransitionStore from "../../state/transitions";
import { useHelper } from "@react-three/drei";

const SpotLight = ({ displayModeOverride }) => {
  const desktopDisplayMode = useTransitionStore((s) => s.DisplayMode);
  const DisplayMode = displayModeOverride ?? desktopDisplayMode;
  const DayMode = useTransitionStore((s) => s.DayMode);

  const { distance, intensity, Y, decay, penumbra, enabled } = useControls({
    LightsPowerTrain: folder({
      distance: {
        value: DayMode == "night" ? 15 : 2,
        min: 0,
        max: 30,
        step: 0.001,
      }, //3.6
      intensity: { value: 6, min: 0, max: 20, step: 0.001 },
      Y: { value: 1.13, min: 0, max: 20, step: 0.001 },
      decay: { value: 0, min: 0, max: 20, step: 0.001 },
      penumbra: { value: 1.86, min: 0, max: 5, step: 0.001 },
    }),
  });
  const spotLight = useRef();

  // useHelper(spotLight, three.SpotLightHelper, "cyan");

  return (
    <>
      <spotLight
        // visible={false}
        // visible={DisplayMode == "powertrain"}
        // visible={DisplayMode == "powertrain" || DisplayMode == "flipper"}
        visible={
          DisplayMode == "powertrain" ||
          DisplayMode == "flipper" ||
          DayMode === "night"
        }
        ref={spotLight}
        distance={distance}
        intensity={DisplayMode == "powertrain" ? intensity : 0.2}
        rotation={[-Math.PI / 2, 0, 0]}
        position={[
          0,
          DisplayMode == "powertrain" ? Y : 15.12,
          DisplayMode == "powertrain" ? 0 : 0,
        ]}
        color={DisplayMode == "powertrain" ? "#005099" : "rgb(256,256,256)"}
        decay={DisplayMode == "powertrain" ? decay : 0.1}
        penumbra={penumbra}
        // angle={Math.PI / 10}
      />
    </>
  );
};

export default React.memo(SpotLight);
